import { useState, useEffect } from "react";

import { Box, CircularProgress } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

import ListItem from "../../atoms/mui/ListItem";
import usePermissions from "../../../helpers/hooks/usePermissions";

const CompanyDataListItem = ({
  editingComponent,
  saveDisabled,
  onCancel = () => {},
  onSave = () => {},
  secondaryText,
  saveLoading,
  isTextField,
  isUpdated,
  ...otherProps
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const { canEdit } = usePermissions();

  useEffect(() => {
    if (isUpdated) setIsEditing(true);

    if (!isUpdated) setIsEditing(false);
  }, [isUpdated]);

  return (
    <ListItem
      listContent={<Box py={1}>{editingComponent}</Box>}
      secondaryText={secondaryText}
      {...otherProps}
      actions={
        isTextField
          ? isEditing
            ? [
                {
                  tooltip: "Cancel Changes",
                  icon: <CancelIcon />,
                  onClick: () => {
                    onCancel();
                    return setIsEditing(false);
                  }
                },
                {
                  tooltip: "Save Changes",
                  icon: saveLoading ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    <SaveIcon />
                  ),
                  disabled: saveDisabled || saveLoading || !canEdit,
                  onClick: async () => {
                    await onSave();
                    return setIsEditing(false);
                  }
                }
              ]
            : []
          : []
      }
    />
  );
};
export default CompanyDataListItem;
